import { SummaryRecurrentModel } from '../../models/summary-recurrent.model';
import { LoadRecurrentsSuccess, RecurrentActions, RecurrentActionTypes } from '../actions/recurrent.actions';

export interface RecurrentState {
  items: SummaryRecurrentModel[];
  total: number;
  loading: boolean;
  error: any;
}

export const initialState: RecurrentState = {
  items: [],
  total: 0,
  loading: false,
  error: null
};

export function RecurrentReducer(
  state = initialState,
  action: RecurrentActions
): RecurrentState {
  switch (action.type) {
    case RecurrentActionTypes.LoadRecurrents:
      return { ...state, loading: true, error: null };
    case RecurrentActionTypes.LoadRecurrentsSuccess: {
      const { items, total } = (action as LoadRecurrentsSuccess).payload;
      return { ...state, loading: false, items, total };
    }
    case RecurrentActionTypes.LoadRecurrentsFailure:
      return { ...state, loading: false, error: (action as any).payload.error };
    default:
      return state;
  }
}
